import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import { Checkbox, Box, Typography, Paper, Divider, Card, CardContent } from '@mui/material';
import {
  FormControl,
  Grid,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  MenuItem,
} from '@mui/material';
import Swal from 'sweetalert2';
import { Modal } from '../../components/BootstrapToMUI';
import request from '../../services/Request';
import { useTheme } from '@mui/material/styles';

export default function EditUserModal(props) {
  const theme = useTheme();
  const [viewButton, setviewButton] = useState('Check All View');
  const { data, setReflesh, reflesh, user, ...rest } = props;
  const defaultValues = {
    access: '0',
    view_machine: true,
    edit_machine: false,
    view_prod: true,
    edit_prod: false,
    view_cate: true,
    edit_cate: false,
    view_brand: true,
    edit_brand: false,
    view_receipt: true,
    edit_receipt: false,
    view_ss: true,
    edit_ss: false,
    edit_group: false,
    edit_user: false,
    view_plano: true,
    edit_plano: false,
    view_promo: true,
    edit_promo: false,
    view_report: true,
    view_trans: true,
    view_member: true,
    edit_member: false,
    stocking: false,
    write: false,
  };
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({ defaultValues });

  const checkAllView = () => {
    if (viewButton === 'Check All View') {
      setValue('view_machine', true);
      setValue('view_prod', true);
      setValue('view_cate', true);
      setValue('view_brand', true);
      setValue('view_receipt', true);
      setValue('view_ss', true);
      setValue('view_plano', true);
      setValue('view_promo', true);
      setValue('view_report', true);
      setValue('view_trans', true);
      setValue('view_member', true);
      setviewButton('Uncheck All View');
    } else {
      setValue('view_machine', false);
      setValue('view_prod', false);
      setValue('view_cate', false);
      setValue('view_brand', false);
      setValue('view_receipt', false);
      setValue('view_ss', false);
      setValue('view_plano', false);
      setValue('view_promo', false);
      setValue('view_report', false);
      setValue('view_trans', false);
      setValue('view_member', false);

      setValue('edit_machine', false);
      setValue('edit_prod', false);
      setValue('edit_cate', false);
      setValue('edit_brand', false);
      setValue('edit_receipt', false);
      setValue('edit_ss', false);
      setValue('edit_group', false);
      setValue('edit_user', false);
      setValue('edit_plano', false);
      setValue('edit_promo', false);
      setValue('edit_member', false);
      setviewButton('Check All View');
    }
  };

  const myOnchange = (field, e) => {
    const name = field.substring(4);
    if (field.includes('view')) {
      const view = field;
      const edit = 'edit' + name;
      if (!e.target.checked) {
        setValue(view, e.target.checked);
        setValue(edit, e.target.checked);
      } else {
        setValue(view, e.target.checked);
      }
    } else {
      const edit = field;
      const view = 'view' + name;
      if (e.target.checked) {
        setValue(view, e.target.checked);
        setValue(edit, e.target.checked);
      } else {
        setValue(edit, e.target.checked);
      }
    }
    if (field === 'write') {
      if (e.target.checked) {
        setValue('write', e.target.checked);
        setValue('stocking', e.target.checked);
      } else {
        setValue('write', e.target.checked);
      }
    }
    if (field === 'stocking') {
      if (!e.target.checked) {
        setValue('write', e.target.checked);
        setValue('stocking', e.target.checked);
      } else {
        setValue('stocking', e.target.checked);
      }
    }
  };

  useEffect(() => {
    if (props.show && data) {
      reset({
        role: data.role,
        access: data.fullAccess ? '1' : '0',
        view_machine: data.limits.view_machine,
        edit_machine: data.limits.edit_machine,
        view_prod: data.limits.view_prod,
        edit_prod: data.limits.edit_prod,
        view_cate: data.limits.view_cate,
        edit_cate: data.limits.edit_cate,
        view_brand: data.limits.view_brand,
        edit_brand: data.limits.edit_brand,
        view_receipt: data.limits.view_receipt,
        edit_receipt: data.limits.edit_receipt,
        view_ss: data.limits.view_ss,
        edit_ss: data.limits.edit_ss,
        edit_group: data.limits.edit_group,
        edit_user: data.limits.edit_user,
        view_plano: data.limits.view_plano,
        edit_plano: data.limits.edit_plano,
        view_promo: data.limits.view_promo,
        edit_promo: data.limits.edit_promo,
        view_member: data.limits.view_member,
        edit_member: data.limits.edit_member,
        view_report: data.limits.view_report,
        view_trans: data.limits.view_trans,
        stocking: data.stocking ? true : false,
        write: data.stocking_write ? true : false,
      });
    }
  }, [props.show]);

  const watchAll = watch();

  const onSubmit = async (data) => {
    // console.log(data);
    const access = data.access === '1' ? true : false;
    let limits = {
      view_machine: data.view_machine,
      edit_machine: data.edit_machine,
      view_prod: data.view_prod,
      edit_prod: data.edit_prod,
      view_cate: data.view_cate,
      edit_cate: data.edit_cate,
      view_brand: data.view_brand,
      edit_brand: data.edit_brand,
      view_receipt: data.view_receipt,
      edit_receipt: data.edit_receipt,
      view_ss: data.view_ss,
      edit_ss: data.edit_ss,
      edit_group: data.edit_group,
      edit_user: false,
      view_plano: data.view_plano,
      edit_plano: data.edit_plano,
      view_promo: data.view_promo,
      edit_promo: data.edit_promo,
      view_member: data.view_member,
      edit_member: data.edit_member,
      view_report: data.view_report,
      view_trans: data.view_trans,
    };
    if (access) {
      limits = {
        view_machine: true,
        edit_machine: true,
        view_prod: true,
        edit_prod: true,
        view_cate: true,
        edit_cate: true,
        view_brand: true,
        edit_brand: true,
        view_receipt: true,
        edit_receipt: true,
        view_ss: true,
        edit_ss: true,
        edit_group: true,
        edit_user: true,
        view_plano: true,
        edit_plano: true,
        view_promo: true,
        edit_promo: true,
        view_member: true,
        edit_member: true,
        view_report: true,
        view_trans: true,
      };
    }
    await request({
      method: 'patch',
      url: '/users/limits',
      data: {
        id: props.data._id,
        fullAccess: access,
        limits: limits,
        stocking: data.stocking,
        stocking_write: data.write,
      },
    }).then((res) => {
      Swal.fire({
        text: `The user has been successfully updated`,
        icon: 'success',
      }).then(() => {
        reflesh ? setReflesh(false) : setReflesh(true);
        props.onHide();
      });
    });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          sx={{ fontSize: '1.2rem', fontWeight: 600 }}
        >
          Edit User Access Level
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body" sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Box sx={{ px: 2, py: 1 }}>
            {/* Access Level Section */}
            <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                backgroundColor:
                  theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                borderRadius: 1.5,
              }}
            >
              <FormControl component="fieldset" fullWidth>
                <FormLabel
                  component="legend"
                  sx={{
                    fontSize: '0.95rem',
                    fontWeight: 600,
                    mb: 1,
                    color: theme.palette.text.primary,
                  }}
                >
                  User Access Level
                </FormLabel>
                <Controller
                  control={control}
                  name="access"
                  render={({ field }) => (
                    <RadioGroup
                      aria-label="Role"
                      name="Role1"
                      row
                      {...field}
                      value={watchAll.access}
                      sx={{ gap: 2 }}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio size="small" />}
                        label={<Typography sx={{ fontSize: '0.9rem' }}>Full Access</Typography>}
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio size="small" />}
                        label={<Typography sx={{ fontSize: '0.9rem' }}>Limited Access</Typography>}
                      />
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Paper>

            {/* Quick Actions */}
            <Box sx={{ mb: 2 }}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={checkAllView}
                size="small"
                sx={{ py: 0.8 }}
              >
                {viewButton}
              </Button>
            </Box>

            {/* Stocking Permissions - Inline */}
            <Grid container spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                <Controller
                  name="stocking"
                  control={control}
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      size="small"
                      checked={watchAll.stocking}
                      onChange={(e) => {
                        myOnchange(field.name, e);
                      }}
                    />
                  )}
                />
                <Typography sx={{ fontSize: '0.875rem' }}>Stocking (Read)</Typography>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                <Controller
                  name="write"
                  control={control}
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      size="small"
                      checked={watchAll.write}
                      onChange={(e) => {
                        myOnchange(field.name, e);
                      }}
                    />
                  )}
                />
                <Typography sx={{ fontSize: '0.875rem' }}>Stocking (Write)</Typography>
              </Grid>
            </Grid>

            {watchAll.access == '0' && (
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  backgroundColor:
                    theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                  borderRadius: 1.5,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, mb: 1, fontSize: '0.95rem' }}
                >
                  Feature Permissions
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_machine"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_machine}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Machine</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_machine"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_machine}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Machine</Typography>
                  </Grid>

                  {user?.features?.mobile && (
                    <>
                      <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                        <Controller
                          name="view_member"
                          control={control}
                          render={({ field }) => (
                            <Checkbox
                              {...field}
                              size="small"
                              checked={watchAll.view_member}
                              onChange={(e) => {
                                myOnchange(field.name, e);
                              }}
                            />
                          )}
                        />
                        <Typography sx={{ fontSize: '0.875rem' }}>View Member</Typography>
                      </Grid>
                      <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                        <Controller
                          name="edit_member"
                          control={control}
                          render={({ field }) => (
                            <Checkbox
                              {...field}
                              size="small"
                              checked={watchAll.edit_member}
                              onChange={(e) => {
                                myOnchange(field.name, e);
                              }}
                            />
                          )}
                        />
                        <Typography sx={{ fontSize: '0.875rem' }}>Edit Member</Typography>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_prod"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_prod}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Product</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_prod"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_prod}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Product</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_cate"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_cate}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Category</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_cate"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_cate}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Category</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_brand"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_brand}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Brand</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_brand"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_brand}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Brand</Typography>
                  </Grid>

                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_receipt"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_receipt}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Receipt</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_receipt"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_receipt}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Receipt</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_ss"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_ss}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Screen Saver</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_ss"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_ss}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Screen Saver</Typography>
                  </Grid>

                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_plano"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_plano}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Planogram</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_plano"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_plano}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Planogram</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_promo"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.view_promo}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Promotion</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_promo"
                      control={control}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          size="small"
                          checked={watchAll.edit_promo}
                          onChange={(e) => {
                            myOnchange(field.name, e);
                          }}
                        />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Promotion</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_report"
                      control={control}
                      render={({ field }) => (
                        <Checkbox {...field} size="small" checked={watchAll.view_report} />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Report</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="edit_group"
                      control={control}
                      render={({ field }) => (
                        <Checkbox {...field} size="small" checked={watchAll.edit_group} />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>Edit Group</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', py: 0.3 }}>
                    <Controller
                      name="view_trans"
                      control={control}
                      render={({ field }) => (
                        <Checkbox {...field} size="small" checked={watchAll.view_trans} />
                      )}
                    />
                    <Typography sx={{ fontSize: '0.875rem' }}>View Transaction</Typography>
                  </Grid>
                </Grid>
              </Paper>
            )}

            {/* Submit Button */}
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                sx={{
                  minWidth: 180,
                  py: 1.2,
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
              >
                Save Changes
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
